import gsap from 'gsap'

import Site from 'stores/Site'

export default class Tabs {
    constructor(el) {
        if (Site.isMobile) return

        this.btns = el.querySelectorAll('.tab-button')
        this.panes = el.querySelectorAll('.tab-pane')
        const heights = []

        this.panes.forEach(pane => {
            heights.push(pane.offsetHeight)
        })

        gsap.set(el, {
            minHeight: Math.max(...heights)
        })

        this.btns.forEach(btn => {
            btn.addEventListener('click', () => {
                if (btn.classList.contains('active')) return

                this.toggle(btn.getAttribute('data-id'))
            })
        })
    }

    toggle(id) {
        this.btns.forEach(btn => {
            btn.classList.remove('active')

            if (btn.getAttribute('data-id') === id) {
                btn.classList.add('active')
            }
        })

        this.panes.forEach(pane => {
            pane.classList.remove('active')

            if (pane.getAttribute('data-id') === id) {
                pane.classList.add('active')
            }
        })
    }
}